const ReactInstructionJs = () => {
  return (
    <div className="instructions">
      <p>2.Copy the provided code and paste it into the same component where you previously pasted it, specifically in the functional area of the React component</p>
    </div>
  )
}
export default ReactInstructionJs